import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import ManageLinkedUsers from "./routes/ManageLinkedUsers";
import { injectReducer } from "store/reducers";
export default store => ({
  path: "accessManager",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(
          /* webpackChunkName: "administrator-tooling" */ "./AccessManager"
        ),
        import(
          /* webpackChunkName: "administrator-tooling" */ "Tooling/modules/ToolingModule"
        ),
      ]).then(([importedModule0, importedModule1]) => {
        const component = importedModule0.default;
        const reducer = importedModule1.default;
        injectReducer(store, {
          key: "tooling",
          reducer,
        });
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [ManageLinkedUsers(store)],
});
